import { createContext, useContext } from 'react';

export const AttendanceContext = createContext(); // Export the TableContext

export const useAttendanceContext = () => useContext(AttendanceContext);
